// These links require for something to happen in their functions
// to work properly. We disable them here
function setupDependantLinks(){
  var rules = [
      //["the rule to search", "class-that-i-will-add-to-the-link"],

      // for the credit counseling system out links to pass referrer info custom/set-referrers.js
      ["a[href*='https://www.advantageuser.org/devocc/api/0.1/get-started.php']"], 
      ["a[href*='https://www.advantageuser.org/occ/api/0.1/get-started.php']"],

      // for the advisor and bank counseling system out links to pass referrer info custom/set-referrers.js
      ["a[href*='/counseling/index.php']"],
      ["a[href*='/counseling/bankruptcy_begin.cfm']"],
      ["a[href*='/DevBank/index.php']"],
      ["a[href*='/DevAdvisor/index.php']"],
      ["a[href*='/BudgetAdvisor/index.php']"],
      ["a[href*='login.php']"],
      ["a[href*='onlinebudgetadvisor.com']"]
    ];

  rules.forEach(disableLink);

  function disableLink(link) {
    if(!link || link.length <= 0 ) return;
    var disableLinkClass = (link[1]) ? (link[1]) : null;
    var lnks = document.querySelectorAll(link[0]);
    
    disableLinks(lnks, disableLinkClass);
  }  
}